import React from 'react';
import AuthorCard from './AuthorCard';

export default function PublicationContentBlock({ contentBlock, htmlSerializer }) {
  const { authorProps } = contentBlock;
  return (
    <>{authorProps && <AuthorCard authorProps={authorProps} htmlSerializer={htmlSerializer} />}</>
  );
}
